module.exports = __webpack_public_path__ + "img/dark.2aca0d9b.png";